import React from 'react';
import Icon from './AppIcon';
import config from '../config';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <Icon name="Layers" size={32} color="#FFFFFF" />
          </div>
          <h1 className="text-h3 font-heading font-semibold text-foreground mb-2">
            {title || config.appName}
          </h1>
          {subtitle && (
            <p className="text-text-secondary">
              {subtitle}
            </p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;